var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "quiz-container",
    { staticClass: "quiz-init-container", attrs: { loading: _vm.loading } },
    [
      _c("template", { slot: "content" }, [
        _c("img", {
          staticClass: "quiz-image",
          attrs: {
            src: _vm.apiImageUrl(_vm.quizImage),
            alt: "Quiz header image"
          }
        }),
        _vm._v(" "),
        _c("h2", { staticClass: "quiz-text" }, [
          _vm._v(_vm._s(_vm.quizMessage))
        ])
      ]),
      _vm._v(" "),
      _c("template", { slot: "cta-buttons" }, [
        _c(
          "button",
          {
            staticClass: "button pink",
            class: { "main-button": !_vm.hasTakedQuiz },
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.goToQuiz.apply(null, arguments)
              }
            }
          },
          [_vm._v(_vm._s(_vm.hasTakedQuiz ? "Start New" : "Take Quiz"))]
        ),
        _vm._v(" "),
        _vm.hasTakedQuiz
          ? _c(
              "button",
              {
                staticClass: "button gray",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.goToResults.apply(null, arguments)
                  }
                }
              },
              [_vm._v("View Results")]
            )
          : _vm._e()
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b9994cc", { render: render, staticRenderFns: staticRenderFns })
  }
}